import React from "react";
import type { IIntegrationFormImplProps } from "src/integrations/forms/IIntegrationFormImplProps";
import { ShopifyIsRestrictedInput } from "src/integrations/forms/shopify/inputs/ShopifyIsRestrictedInput";
import { IntegrationFormShopify } from "src/integrations/forms/shopify/IntegrationFormShopify";

export const IntegrationFormShopifyCustomer = (
  props: IIntegrationFormImplProps,
) => {
  return (
    <IntegrationFormShopify {...props} apiKeyRequired showsAccessToken={false}>
      <ShopifyIsRestrictedInput {...props} />
    </IntegrationFormShopify>
  );
};
